import React, { useEffect, useState } from "react";
import Select from "react-select";
import { reportOption } from "../../utilities";
import { connect, useDispatch } from "react-redux";
import { updateReportAction } from "../../store/actions/AuthActions";
const Reportselect = ({ reportType }) => {
  const dispatch = useDispatch();

  return (
    <div>
      <Select
        className="react-select"
        classNamePrefix="select"
        options={reportOption}
        value={reportType}
        onChange={(selected) => {
          dispatch(updateReportAction(selected));
        }}
        styles={{
          menu: (provided) => ({
            ...provided,
            zIndex: 9999,
          }),
        }}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  reportType: state.auth.reportType,
});

export default connect(mapStateToProps)(Reportselect);
